'use client';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="de">
      <body
        style={{
          minHeight: '100vh',
          margin: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: 'system-ui, sans-serif',
          background: '#0a0a0a',
          color: '#ededed',
          padding: '2rem',
        }}
      >
        <h1 style={{ fontSize: '1.5rem', fontWeight: 600 }}>
          Etwas ist schiefgegangen
        </h1>
        <p style={{ marginTop: '0.5rem', color: '#a1a1aa', maxWidth: '32rem' }}>
          {error.message || 'Ein unerwarteter Fehler ist aufgetreten.'}
        </p>
        {error.digest && (
          <code style={{ marginTop: '0.5rem', color: '#71717a', fontSize: '0.75rem' }}>
            digest: {error.digest}
          </code>
        )}
        <button
          type="button"
          onClick={() => reset()}
          style={{
            marginTop: '1.5rem',
            background: '#fafafa',
            color: '#18181b',
            border: 'none',
            borderRadius: '0.375rem',
            padding: '0.5rem 1rem',
            fontWeight: 500,
            cursor: 'pointer',
          }}
        >
          Erneut versuchen
        </button>
      </body>
    </html>
  );
}
